import React from 'react';

const DraggableRect = () => {
  return <div>asd</div>;
}

export { DraggableRect };
